// Attribution Google Ads (GCLID, mot-clé) + choix cookies (RGPD / Consent Mode v2)
const CONSENT_KEY = 'cookieConsent';
const UTM_KEY = 'utm_params';
let memoryUtm = null;

export const hasAdConsent = () => ['all', 'true'].includes(localStorage.getItem(CONSENT_KEY));

const readStored = () => {
  if (!hasAdConsent()) return {};
  try { return JSON.parse(localStorage.getItem(UTM_KEY) || '{}'); } catch (e) { return {}; }
};

// Without consent, attribution stays in memory for the visit only (nothing written on the device)
export const getUtmParams = () => {
  const stored = memoryUtm || readStored();
  const params = new URLSearchParams(window.location.search);
  const fromUrl = {
    keyword: params.get('keyword') || params.get('utm_term') || params.get('kw') || params.get('q') || params.get('query') || '',
    gclid: params.get('gclid') || '',
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || params.get('campaign') || '',
  };
  const utmData = Object.values(fromUrl).some(Boolean)
    ? { ...fromUrl, referrer: document.referrer || '', landing_url: window.location.href }
    : { ...stored, referrer: stored.referrer || document.referrer || '', landing_url: stored.landing_url || window.location.href };

  memoryUtm = utmData;
  if (hasAdConsent()) localStorage.setItem(UTM_KEY, JSON.stringify(utmData));
  else localStorage.removeItem(UTM_KEY);
  return { ...utmData, ad_user_data_consent: hasAdConsent() ? 'GRANTED' : 'DENIED' };
};

export const setCookieConsent = (choice) => {
  localStorage.setItem(CONSENT_KEY, choice);
  const state = choice === 'all' ? 'granted' : 'denied';
  if (window.gtag) {
    window.gtag('consent', 'update', { ad_storage: state, ad_user_data: state, ad_personalization: state, analytics_storage: state });
  }
  getUtmParams();
};

export const resetCookieConsent = () => {
  localStorage.removeItem(CONSENT_KEY);
  localStorage.removeItem(UTM_KEY);
  window.location.reload();
};
